// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"style_breadcrumbs__1GI9-","current":"style_current__2oTdN","arrow":"style_arrow__2FG0q"};